import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title-background" }
const _hoisted_2 = { class: "text-h3 font-weight-medium" }
const _hoisted_3 = { class: "f-20 mt-1 mb-8" }
const _hoisted_4 = { class: "f-16 mb-5" }
const _hoisted_5 = { class: "f-16 mb-0" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "f-16 mb-1" }
const _hoisted_9 = { class: "f-14 mb-0" }
const _hoisted_10 = { class: "f-20 mr-3" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "mt-6 d-flex justify-center" }

import { computed } from 'vue';

// Local Components
import BannerBox from '@/components/widgets/BannerBox/BannerBox.vue';
import BaseButton from '@/components/widgets/BaseButton.vue';
import DonorSteps from '@/components/widgets/DonorSteps.vue';
import FAQPanels from '@/components/widgets/FAQPanels.vue';
import FooterComponent from '@/components/widgets/FooterComponent.vue';
import ReturnLink from '@/components/widgets/ReturnLink.vue';
import TitleHeader from '@/components/widgets/TitleHeader.vue';

// Constants
import { LINKS } from '@/constants/externalLinks';
import { THANKS_PAGE_FAQ } from '@/constants/faq';

// Utilities
import InfoSectionThanks from '@/components/Home/InfoSection/InfoSectionThanks.vue';
import { useDonorStore } from '@/stores/Donor';
import getLangsVariable from '@/utils/getLangsVariable';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'ThanksPage',
  setup(__props) {

// Vue
const { t, tm } = useI18n();

const donorStore = useDonorStore();
const donor = computed(() => donorStore.donor);

// Construct the family URL
const familyUrl = computed<string>(() => {
    if (!donor.value) return '';
    const { familyEditionId, warehouseId } = donor.value;

    const url = new URL(window.location.href);
    const PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH ?? '/';
    url.pathname = `${PUBLIC_PATH}rodzina/${familyEditionId}/${warehouseId}`;

    return url.href;
});

const familyUrlChosen = computed<string>(() => `${familyUrl.value}?context=family_choosen`);

const callCenter = {
    phone: getLangsVariable(['OTHER', 'callCenter', 'phone']) || t('footer.callCenter.phone'),
    text: getLangsVariable(['OTHER', 'callCenter', 'text']) || t('footer.callCenter.text')
};

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createBlock(_component_v_main, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TitleHeader, {
          title: _ctx.$t('thanks.subtitle'),
          subtitle: _ctx.$t('thanks.title')
        }, null, 8, ["title", "subtitle"])
      ]),
      _createVNode(_component_v_container, { class: "pb-0 mb-12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            class: "mt-3",
            "no-gutters": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "mb-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(ReturnLink, {
                    label: _ctx.$t('familiesList.returnToMainPage'),
                    "to-name": "home"
                  }, null, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "mt-3 sz-primary-background pa-4 pa-sm-5"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "sz-primary-grey--text"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('thanks.header')), 1),
                  _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('thanks.subheader')), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "border-bottom mb-5" }, null, -1))
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "flex-nowrap"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "1",
                        sm: "auto"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: 25,
                            color: "szLightGrey",
                            class: "mt-1"
                          }, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                              _createTextVNode(" $email ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "11",
                        sm: "auto",
                        class: "sz-primary-grey--text font-weight-regular pl-3"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('thanks.emailInfo')), 1),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_5, [
                              _createElementVNode("a", {
                                class: "f-16 primary-link pointer",
                                href: familyUrlChosen.value,
                                target: "_blank"
                              }, _toDisplayString(_ctx.$t('thanks.familyLink.1')), 9, _hoisted_6),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('thanks.familyLink.2')), 1)
                            ]),
                            _createElementVNode("input", {
                              id: "textToCopy",
                              type: "hidden",
                              value: familyUrl.value
                            }, null, 8, _hoisted_7)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "flex-nowrap mt-5"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "1",
                        sm: "auto"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: 25,
                            color: "szLightGrey",
                            class: "mt-1"
                          }, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createTextVNode(" $chat ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "11",
                        sm: "auto",
                        class: "sz-primary-grey--text font-weight-regular pl-3"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('thanks.volunteerInfo')), 1),
                          _createElementVNode("p", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(callCenter.phone), 1),
                            (callCenter.text)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(callCenter.text), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_container, { class: "py-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(DonorSteps, {
                    title: _unref(t)('home.thanksSteps.title'),
                    steps: _unref(tm)('home.thanksSteps.steps'),
                    "guide-button-text": _ctx.$t('label.showGuide'),
                    "center-steps-text": false,
                    class: "thanks-page__donor-steps"
                  }, null, 8, ["title", "steps", "guide-button-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(InfoSectionThanks),
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(FAQPanels, { faq: _unref(THANKS_PAGE_FAQ) }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(BaseButton, {
                          href: _unref(LINKS).guide,
                          variant: "secondary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('label.showGuide')), 1)
                          ]),
                          _: 1
                        }, 8, ["href"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["faq"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(BannerBox, _normalizeProps(_guardReactiveProps(_unref(tm)('banners.APThanksPage'))), null, 16)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(FooterComponent)
    ]),
    _: 1
  }))
}
}

})